import AsyncStorage from "@react-native-community/async-storage";
import React, { useEffect } from "react";
import {
  View,
  Text,
  ImageBackground,
  ScrollView,
  Image,
  TouchableOpacity,
  Dimensions,
} from "react-native";

import Menu from "../menu";
import style from "./style";

export default class VideoPantallaComplerta extends React.Component {
  constructor(props) {
    super(props);
    this.state = props.route.params;
  }

  closeCall = () => {
    AsyncStorage.removeItem("lastPoiTrucada");
    this.state.navigation.navigate("Home", RouterData.route.params);
  };

  // RouterData.navigation.addListener('blur',()=>{
  //     document.getElementById('audio2').remove('audio')
  // });

  render() {
    return (
      <View style={{ flex: 1 }}>
        <View
          style={{
            height: "100%",
            width: "100%",
            backgroundColor: "black",
            alignSelf: "center",
            justifyContent: "center",
          }}
        >
          <div id="container">
            <div id="audioTrucada"></div>
            <video
              id="video"
              autoPlay
              style={{
                height: "100%",
                width: "100vw",
                resizeMode: "cover",
                objectFit: "cover",
                position: "fixed",
                left: 0,
                top: 0,
                zIndex: -1,
              }}
            >
              <source
                id="videoSource"
                src={require("../../assets/Videos/Vinyet"+this.state.idioma+".mp4")}
                type="video/mp4"
              />
            </video>
          </div>
        </View>
        <View
          style={{
            flex: 0.05,
            bottom: 25,
            left: 0,
            right: 0,
            position: "fixed",
          }}
        >
          {/*era 70 */}
          <View style={{ flexDirection: "row", width: "100%" }}>
            <Image
              source={require("../../img/cam.png")}
              style={{
                height: this.state.pop_up_height * 0.18,
                width: "33%",
                resizeMode: "contain",
                alignSelf: "center",
              }}
            />
            <TouchableOpacity
              style={{ width: "33%" }}
              onPress={() => {
                this.props.navigation.navigate("Home", this.state);
              }}
            >
              <Image
                source={require("../../img/closeCall.png")}
                style={{
                  height: this.state.pop_up_height * 0.18,
                  width: "100%",
                  resizeMode: "contain",
                  alignSelf: "flex-start",
                }}
              />
            </TouchableOpacity>
            <Image
              source={require("../../img/miss.png")}
              style={{
                height: this.state.pop_up_height * 0.18,
                width: "33%",
                resizeMode: "contain",
                alignSelf: "flex-end",
              }}
            />
          </View>
        </View>
      </View>
    );
  }
}
